import { Link } from "react-router-dom";
import styled from "styled-components";
import { EmptyState } from "../../../../assets/svgIcon/listView/EmptyState";

/**
 * Message shown when a list or panel has nothing to display.
 *
 * Called with no props it keeps the original "No data found" look, so screens
 * that have not been given friendlier copy still render as before.
 *
 * @param {{
 *   title?: string,
 *   description?: string,
 *   actions?: !Array<{label: string, to?: string, onClick?: function(), primary?: boolean}>,
 * }} props
 */
export const EmptyStateComp = ({ title = "No data found", description, actions = [] }) => {
  return (
    <EmptyStateCompCss>
      <EmptyState />
      <div className="noData">{title}</div>
      {description ? <p className="emptyDescription">{description}</p> : null}
      {actions.length > 0 ? (
        <div className="emptyStateActions">
          {actions.map(({ label, to, onClick, primary }) => {
            const className = `btn btn-sm ${primary ? "btn-primary" : "btn-light-primary"}`;
            return to ? (
              <Link key={label} className={className} to={to}>
                {label}
              </Link>
            ) : (
              <button key={label} type="button" className={className} onClick={onClick}>
                {label}
              </button>
            );
          })}
        </div>
      ) : null}
    </EmptyStateCompCss>
  );
};

const EmptyStateCompCss = styled.div`
  margin-top: 55px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  position: absolute;
  left: 50%;
  translate: -50%;
  z-index: 0;
  pointer-events: none;
  max-width: 460px;
  text-align: center;
  .noData {
    color: var(--GREY, #4a4a68);
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.4px;
  }
  .emptyDescription {
    color: var(--GREY, #4a4a68);
    font-size: 14px;
    margin: 0;
    white-space: normal;
  }
  .emptyStateActions {
    display: flex;
    gap: 8px;
    pointer-events: auto;
  }
`;
